import { onBeforeUnmount, ref } from 'vue'

export const PHONE_MEDIA_QUERY = '(max-width: 820px)'

export function useMediaQuery(query) {
  const matches = ref(false)
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return matches
  const list = window.matchMedia(query)
  const update = () => {
    matches.value = list.matches
  }
  update()
  list.addEventListener('change', update)
  onBeforeUnmount(() => list.removeEventListener('change', update))
  return matches
}
